import { createContainer } from 'brandi';
import { bindGateways } from './bindGateways';

import { bindRepositories } from './bindRepositories';
import { bindServices } from './bindServices';

export const container = createContainer();

bindRepositories(container);

bindServices(container);

bindGateways(container);
